import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Route, Switch } from 'wouter';
import { AuthProvider, useAuth } from './auth.tsx';
import { Layout } from './components/Layout.tsx';
import { AddCardPage } from './pages/AddCardPage.tsx';
import { CardPage } from './pages/CardPage.tsx';
import { CollectionPage } from './pages/CollectionPage.tsx';
import { InvitePage } from './pages/InvitePage.tsx';
import { LocationPage } from './pages/LocationPage.tsx';
import { LogPage } from './pages/LogPage.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { GalleryPage } from './pages/GalleryPage.tsx';
import { GalleryDeckPage, PublicDeckPage } from './pages/PublicDeckPage.tsx';
import { SearchPage } from './pages/SearchPage.tsx';
import { SettingsPage } from './pages/SettingsPage.tsx';
// Display font for the shared /decks section headings, bundled (the CSP allows only our own fonts).
import '@fontsource/tilt-neon/latin.css';
import './styles.css';

function Routes() {
  const { state } = useAuth();

  return (
    <Switch>
      {/* Shared decks and the all-decks gallery are public (decision A4): no sign-in, whatever the state. */}
      <Route path="/d/:slug">{(params) => <PublicDeckPage slug={params.slug} />}</Route>
      <Route path="/decks" component={GalleryPage} />
      <Route path="/decks/:id">{(params) => <GalleryDeckPage id={params.id} />}</Route>
      <Route path="/invite/:token">{(params) => <InvitePage token={params.token} />}</Route>
      <Route>
        {state.status === 'loading' ? null : state.status === 'signedOut' ? (
          <LoginPage />
        ) : (
          <Layout>
            <Switch>
              <Route path="/" component={CollectionPage} />
              <Route path="/search" component={SearchPage} />
              <Route path="/locations/:id">{(params) => <LocationPage id={params.id} />}</Route>
              <Route path="/cards/:id">{(params) => <CardPage id={params.id} />}</Route>
              <Route path="/add" component={AddCardPage} />
              <Route path="/log" component={LogPage} />
              <Route path="/settings" component={SettingsPage} />
              <Route>
                <h1>Not found</h1>
              </Route>
            </Switch>
          </Layout>
        )}
      </Route>
    </Switch>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <Routes />
    </AuthProvider>
  </StrictMode>,
);
